module.exports = __webpack_public_path__ + "features-ic.svg?99a1bd301d42597cecae79ed476a9235";